import extendNode from '../extendNode.mjs'
import Color from '../Color.mjs'
import IconLetters from '../icons/IconLetters.jsx'
import useCommonNode from '../_COMMON/useCommonNode.jsx'
import meta from './metaMdm.mjs'

/**
 * MD 知识模件节点。
 * 仅用于引用依赖 / 引用影响分析图，只读，不提供编辑、挂载与链接能力。
 */
export default () => {
    const CommonNode = useCommonNode()

    return extendNode(CommonNode, {
        ...meta,

        getIcons() {
            return [
                <IconLetters
                    key="type"
                    fill={Color.LIGHT_BLUE}
                />
            ]
        },

        canMountType() {
            return false
        },

        canLinkType() {
            return false
        },
    })
}
